import { AfterViewInit, Component, ElementRef, Input, Output, OnChanges, SimpleChanges, ViewChild, EventEmitter } from '@angular/core';
import { NgControl } from '@angular/forms';
import { SegurancaService } from '@sigepe/ngx-sigepe-seguranca';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { distinctUntilChanged, map, switchMap } from 'rxjs/operators';
import DestroyMixin from 'src/app/components/shared/destroy-mixin';
import { clearValue, CONTROL_CONTAINER_PROVIDER } from '../../control-utils';
import { Item } from '../../models/item';
import { EstruturaComponent, setReadonlyValue, toItem } from '../../estrutura-component-utils';
import { ConsultaSiapeService } from '../../../../services/consulta-siape.service';

@Component({
    selector: 'frq-select-uorg',
    templateUrl: './select-uorg.component.html',
    styleUrls: ['./select-uorg.component.scss'],
    viewProviders: [CONTROL_CONTAINER_PROVIDER]
})
export class SelectUorgComponent extends DestroyMixin(Object) implements OnChanges, EstruturaComponent, AfterViewInit {
    @Input() formControlName = 'codigoUorg';
    @Input() required = false;
    @Input() readonly = false;
    @Input() idOrgao = 0;
    @Input() idUpag = 0;
    @Output() changeCallback? = new EventEmitter<any>();
    @Output() opcoesCarregadas = new EventEmitter<{
        quantidade: number;
        bloqueado: boolean;
    }>();

    @ViewChild(NgControl, { static: true }) select!: NgControl;

    private readonly refresh$ = new BehaviorSubject<string>(null);

    originalReadonlyValue;
    uorgsItens;

    constructor(
        private estruturaService: ConsultaSiapeService,
        public element: ElementRef<HTMLElement>,
        private segurancaService: SegurancaService
    ) {
        super();
        this.originalReadonlyValue = this.readonly;
    }

    onChangeCallback() {
        //console.debug("onChangeCallback >> " + this.changeCallback);
        this.changeCallback.emit();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.idOrgao || changes.idUpag) {
            this.refresh$.next(`${this.idOrgao}${this.idUpag}`);
        }
    }

    private load(): Observable<Item[]> {
        if (!this.idOrgao || !this.idUpag) {
            clearValue(this.select.control);
            return of([]);
        }
        return this.estruturaService.listUorgs(this.idOrgao, this.idUpag).pipe(toItem(this));
    }

    ngAfterViewInit(): void {
        //Se tiver apenas 1 item, bloqueia o campo
        this.refresh$
            .pipe(
                distinctUntilChanged(),
                switchMap(() => this.load())
            )
            .subscribe(itens => {
                this.uorgsItens = itens;
                const quantidade = this.uorgsItens?.length ?? 0;
                const bloqueado = quantidade === 1;
                this.opcoesCarregadas.emit({ quantidade, bloqueado });
                if (this.uorgsItens && this.uorgsItens.length === 1) {
                    setReadonlyValue(this, of(this.uorgsItens[0].id));
                } else {
                    this.readonly = this.originalReadonlyValue;
                    setReadonlyValue(this, of(null));
                }
            });
    }
}
